import React from 'react'
import { Box, Text,Grid } from '@chakra-ui/react';

const Details = [
  {
      id:1, 
      content:'50 Jobs ',
      header:'Marketing and sales',
  },
  {
      id:2, 
      content:'50 Jobs ',
      header:'Information and Technology',
  },
  {
      id:3, 
      content:'50 Jobs ',
      header:'Engineering',
  },
  {
      id:4, 
      content:'50 Jobs ',
      header:'Customer Care',
  },
  {
    id:5, 
    content:'50 Jobs ',
    header:'Human Resource and management',
  },
{
  id:6, 
  content:'50 Jobs ',
  header:'Product Management',
},
{
  id:7, 
  content:'50 Jobs ',
  header:'Human Resource and management',
},
{
id:8, 
content:'50 Jobs ',
header:'Product Management',
},
]
  
  const Feature = ({ header, content}) => {
    return (
      <Box w='full' p='.5rem' boxShadow='base'  rounded='lg' bg='white' cursor='pointer' minH='8rem' display='flex' flexDirection='column' alignItems='center' justifyContent='center' transistion='1s easein' _hover={{color:'#fff !important',bg:'green'}} >
        <Text fontWeight='600' fontSize={['.85rem','1.3rem' ]}textAlign='center'>{header}</Text>
        <Text textAlign='center' mt='1rem' fontSize={['.75rem','1rem' ]}>{content}</Text>
      </Box>
    );
  };
  
  export default function Card() {
    return (
      <Box mt='1rem' p='1rem'>
        <Grid templateColumns={['repeat(2,1fr)','repeat(2,1fr)','repeat(4,1fr)']}   placeItems='center'  gap={5}>
            {Details.map((Detail) =>
            <Feature key={Detail.id} header={Detail.header} content={Detail.content} />
            )}
        </Grid>
      </Box>
    );
  }
  